// Description: Endpoint used to authenticate the user and return a token to access the application.
// Updated: 21/08/2025
// Author: Vitor de Jesus

import axios from 'axios';

export async function AuthLogin(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_AWS_URL}/auth/login`, 
            data,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('Erro inesperado. Tente novamente mais tarde.' )
        }
    }
}
